import type { ReactNode } from 'react'
import { usePageTitleContext } from '@/shared/ui/providers'

type PageTitleInlineProps = {
  actions?: ReactNode
}

export function PageTitleInline({ actions }: PageTitleInlineProps) {
  const { pageTitle } = usePageTitleContext()
  if (pageTitle === null) return null
  const Icon = pageTitle.icon ?? null
  return (
    <div className="mb-2 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-3 shrink-0">
        {Icon ? (
          <div className="flex size-10 shrink-0 items-center justify-center rounded-md border border-primary/25 bg-blaze-soft text-primary dark:border-transparent dark:bg-accent/60 dark:text-foreground">
            <Icon className="size-5" />
          </div>
        ) : null}
        <div className="flex flex-col leading-tight">
          <h1 className="text-2xl font-bold tracking-tight">{pageTitle.title}</h1>
          {pageTitle.subtitle ? (
            <p className="text-xs text-muted-foreground">{pageTitle.subtitle}</p>
          ) : null}
        </div>
      </div>
      {actions}
    </div>
  )
}
